<!-- Restaurant details Modal -->
<ng-template #restaurantDetailModal let-modal>
  <div class="modal-body">
    <div class="restaurants-tab-outer">
      <div class="restro-block">
        <img [businessImage]="restaurantDetails.photo"
          alt="Restaurant" class="restro-view">

        <div class="restro-block-inner">
          <div class="inner-head">
            <h4 class="restro-title" (click)="modal.dismiss('Cross click');" style="cursor: pointer;">
              <span class="count">1.</span> <span>{{restaurantDetails.restaurantName}}</span> <span class="status">
                {{restaurantDetails.status}}
              </span>
            </h4>
            <div *ngIf="restaurantDetails?.rating" class="ratig-inner">
              <h5 class="ratings">{{restaurantDetails.rating}}</h5>
              <span class="rating-icon">
                <img src="./assets/images/ic-primary-rating.svg" alt="Rating">
              </span>
            </div>
          </div>
          <ul class="key-points">
            <li *ngFor="let chip of restaurantDetails.tags | slice:0:visibleChipCount">
              <span>{{ chip }}</span>
            </li>
            <li *ngIf="restaurantDetails.showMore">
              <ng-container *ngFor="let chip of restaurantDetails.tags; let i=index">
                <ng-container *ngIf="i >= visibleChipCount">
                  <span>{{chip}}</span>
                </ng-container>
              </ng-container>
            </li>
            <a *ngIf="restaurantDetails.tags.length > visibleChipCount && !restaurantDetails.showMore"
              class="primary-link" role="button" tabindex="0"
              (mouseover)="showMoreTags(restaurantDetails)" (click)="showMoreTags(restaurantDetails, $event)"
              (keydown.enter)="showMoreTags(restaurantDetails, $event)">{{ '... +' +
              (restaurantDetails.tags.length - visibleChipCount) }}</a>
          </ul>
          <ul class="other-info">
            <li *ngIf="restaurantDetails?.openWeeksHours?.length">
              <img src="./assets/images/ic-clock-primary-light.svg" alt="">
              <ng-container *ngFor="let hours of restaurantDetails?.openWeeksHours; let i = index">
                <ng-container *ngIf="i === 0">
                  <div>{{ hours + '&nbsp;'}}</div>
                  <div [ngbTooltip]="hoursSlot" [triggers]="hoursTooltipTriggers" placement="top" style="margin-left:4px;margin-top:-1px"
                    class="pointer" role="button" tabindex="0" aria-label="Show opening hours for every day"
                    tooltipClass="theme-tooltip" container="body"
                    *ngIf="restaurantDetails?.openWeeksHours.length - 1 != 0">+{{
                    (restaurantDetails?.openWeeksHours.length - 1 > 1) ?
                    restaurantDetails?.openWeeksHours.length
                    - 1 + ' more slots' : restaurantDetails?.openWeeksHours.length - 1 + ' more slot' }} </div>
                </ng-container>
              </ng-container>
              <ng-template #hoursSlot>
                <table>
                  <tbody>
                    <tr *ngFor="let item of  restaurantDetails.toolTipHours; let i = index" class="tooltip-line">
                      <td>
                        <span class="tooltip-day">{{ getDayName(item.day) }}</span>
                      </td>
                      <td>
                        <span class="tooltip-time t-from">{{ item.from }}</span>
                      </td>
                      <td>
                        <span class="tooltip-separator">-</span>
                      </td>
                      <td>
                        <span class="tooltip-time t-to">{{ item.to }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-template>
            </li>
            <li *ngIf="restaurantDetails.address">
              <img src="./assets/images/ic-location.svg" alt="">
              <a *ngIf="restaurantDetails.directionsUrl; else plainAddress" class="address-link"
                 [href]="restaurantDetails.directionsUrl" target="_blank" rel="noopener noreferrer"
                 title="Get directions" [attr.aria-label]="'Get directions to ' + restaurantDetails.restaurantName">{{restaurantDetails.address}}</a>
              <ng-template #plainAddress><span>{{restaurantDetails.address}}</span></ng-template>
            </li>
          </ul>
        </div>
        <app-button [btnText]="'View Business'" [btnTitle]="'View Business'" class="vb-btn-block"
          [btnCss]="'btn btn-primary w-100'"
          (onBtnClick)="modal.dismiss('Cross click');openBusinessDetails();"></app-button>
      </div>
    </div>
  </div>
</ng-template>
